module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/thumb.bc71d57a.jpg";